(ns hai.knowledge.assistants.table
  (:require
   [com.wsscode.pathom3.connect.operation :as pco]
   [hai.sharing.components :as sharing.components]
   [hai.ui.components :as c]
   [hai.ui.components.card :as card]
   [hai.ui.components.collection.bulk-actions :as bulk-actions]
   [hai.ui.components.collection.filters :as filters]
   [hai.ui.components.collection.table :as collection]
   [hai.ui.components.collection.views.cards :as cards]
   [hai.ui.components.collection.views.table :as table]
   [hai.ui.components.new-design.button :as button]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.layout :as layout]
   [hai.web-app.routing :as routing]
   [lambdaisland.deja-fu :as fu]
   [lambdaisland.ornament :as o]
   [reagent.core :as r]))

(o/defstyled dialog-cancel-button button/small
  button/light)

(o/defstyled dialog-delete-button button/small
  button/warning)

(def ^:private edit-icon (icons/mui-icon :outlined :edit))
(def ^:private trash-icon (icons/mui-icon :outlined :delete))
(def ^:private duplicate-icon (icons/mui-icon :outlined :content_copy))

(defn assistants-table
  []
  [collection/component
   {:id ::table
    :query [{:assistants/table
             [{:collection/items [:ai-model-config/uuid
                                  (pco/? :ai-model-config/title)
                                  (pco/? :ai-model-config/description)
                                  :ai-model-config/created-at
                                  :ai-model-config/updated-at
                                  :user.entity/permissions
                                  sharing.components/shared-with-query]}]}]
    :paginate? true
    :bulk-actions [{:title "Delete"
                    :mutation 'assistant/delete
                    :disabled? bulk-actions/disabled?
                    :alert {:content (fn [{:table/keys [selected] :as table} action]
                                       [bulk-actions/content
                                        [c/AlertDialogTitle "Confirm Deletion of Assistants"]
                                        [c/AlertDialogDescription "Are you sure you want to delete the following assistants?"]
                                        (into [:ul]
                                              (map (fn [{:ai-model-config/keys [title]}]
                                                     [:li [:strong title]]))
                                              selected)
                                        [bulk-actions/buttons
                                         [bulk-actions/cancel-button table]
                                         [bulk-actions/confirm-button table action]]])}}]
    ;; TODO default card render
    :card (fn [collection item]
            [card/card
             [cards/card-select-checkbox collection item]
             [cards/column-render collection item]])
    :columns [{:header "Assistant name"
               :render (fn title-render
                         [{:ai-model-config/keys [title uuid]}]
                         [table/table-cell
                          [c/Link
                           {:style   {:cursor "pointer"}
                            :href    (routing/href :tasks/chats {} {:ai-model-config uuid})
                            :variant "ghost"}
                           title]])
               :attr   :ai-model-config/title
               :sort?  true
               :filter (filters/text-search {:placeholder "Assistant name..."})}
              {:header "Description"
               :attr   :ai-model-config/description
               :sort?  true
               :filter (filters/text-search {:placeholder "Description..."})}
              {:header "Created"
               :attr   :ai-model-config/created-at
               :sort?  true
               :render (fn title-render
                         [{:ai-model-config/keys [created-at]}]
                         [table/table-cell
                          (fu/format created-at "dd MMM y")])}
              {:header "Modified"
               :attr   :ai-model-config/updated-at
               :sort?  true
               :render (fn title-render
                         [{:ai-model-config/keys [updated-at]}]
                         [table/table-cell
                          (fu/format updated-at "dd MMM y")])}
              sharing.components/shared-with-column
              {:header ""
               :render (fn more-menu-render
                         [{:ai-model-config/keys [uuid title]}]
                         (r/with-let [!delete-open? (r/atom false)]
                           [:<>
                            [c/AlertDialogRoot
                             {:open         @!delete-open?
                              :onOpenChange #(reset! !delete-open? %)}
                             [c/AlertDialogContent
                              [c/AlertDialogTitle "Confirm Deletion of Assistant"]
                              [c/AlertDialogDescription
                               "Are you sure you want to delete the assistant "
                               [:strong title]
                               "?"]
                              [c/Flex {:justify "end" :gap "3" :mt "4"}
                               [dialog-cancel-button
                                {:text     "Cancel"
                                 :on-click (fn [_] (reset! !delete-open? false))}]
                               [dialog-delete-button
                                {:text     "Delete"
                                 :on-click (fn [_]
                                             (reset! !delete-open? false)
                                             (>e [:fetch
                                                  {:url           (str "/assistant/v0/ai-model-configs/" uuid)
                                                   :method        :delete
                                                   :on-success-fx [[:dispatch [:table/resolve ::table]]]}]))}]]]]
                            [table/more-menu-cell
                             [["Edit"
                               (fn [_]
                                 (>e [:routing/navigate [:tasks/knowledge-config {:ai-model-config/uuid uuid}]]))
                               edit-icon]
                              ["Delete"
                               (fn [_]
                                 (reset! !delete-open? true))
                               trash-icon]
                              ["Duplicate"
                               (fn [_]
                                 (let [url (str "/assistant/v0/ai-model-configs/" uuid "/duplicate")
                                       title (str "Copy of " title)]
                                   (>e [:fetch
                                        {:url           url
                                         :method        :post
                                         :body          {:title title}
                                         :on-success-fx [[:dispatch [:table/resolve ::table]]]}])))
                               duplicate-icon]]]]))}]}])

(defn page
  [_]
  [layout/page
   [layout/breadcrumbs]
   [layout/heading]
   [layout/lead*
    [layout/lead "Build helpful assistants that can answer questions, search your documents and support your workflows—right where your teams already work."]
    [:div.buttons
     [button/light-small
      {:on-click (fn [_]
                   (>e [:routing/navigate-in-new-tab "/chat/slack/v1/A05KNFGBWGL/install"]))
       :text     "Add to Slack"
       :title    "Add humble with @Humble and type /humble-settings to setup"
       :icon     [icons/plus]}]
     [button/dark-small
      {:on-click (fn [_]
                   (>e [:assistant/create {}]))
       :text     "New AI Assistant"
       :icon     [icons/plus]}]]]
   [layout/content
    [assistants-table]]])
